import React from 'react';

/**
 * Reusable loading spinner component.
 * @param {string} size - 'sm' | 'md' | 'lg' (default: 'md')
 * @param {string} message - Optional text shown below the spinner
 * @param {boolean} inline - If true, renders inline (no centering wrapper)
 */
function LoadingSpinner({ size = 'md', message, inline = false }) {
  const sizeClasses = {
    sm: 'h-5 w-5 border-2',
    md: 'h-8 w-8 border-3',
    lg: 'h-12 w-12 border-4',
  };

  const spinner = (
    <div
      className={`${sizeClasses[size] || sizeClasses.md} border-blue-200 border-t-blue-600 rounded-full animate-spin`}
      role="status"
      aria-label="Loading"
      data-testid="loading-spinner"
    />
  );

  if (inline) {
    return (
      <span className="inline-flex items-center gap-2">
        {spinner}
        {message && <span className="text-sm text-gray-500 dark:text-gray-400">{message}</span>}
      </span>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-8 gap-3">
      {spinner}
      {message && <p className="text-sm text-gray-500 dark:text-gray-400">{message}</p>}
    </div>
  );
}

export default LoadingSpinner;
